module.exports = __webpack_public_path__ + "static/media/hall-PB.ba79251a.svg";